<template>
    <el-card>
        <div slot="header" class="move">
            <h3>Closed Applications</h3>
        </div>
        <closed-by-chart :data="datasets" :options="options"></closed-by-chart>
    </el-card>
</template>

<script>
import ClosedByChart from '../../ambition/dashboard/charts/CloseByChart'

export default {
    name: 'ClosedApplicationChart',
    components: {
        ClosedByChart
    },
    props: [
        'closedApplication',
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            closedAppData: [],
            datasets: {},
            options: {
                responsive: true,
                legend: {
                    display: true,
                    labels: {
                        fontFamily: "Poppins",
                        padding: 10,
                        boxWidth: 15,
                        fontSize: 12,
                        fontColor: "#000",
                        fontStyle: "normal"
                    },
                    position: "bottom"
                },
                tooltips: {
                    mode: "label",
                    titleFontFamily: "Poppins",
                    titleFontSize: 13,
                    titleMarginBottom: 15,
                    bodyFontFamily: "Poppins",
                    bodyFontSize: 13,
                    bodySpacing: 15,
                    cornerRadius: 0,
                    xPadding: 15,
                    yPadding: 15,
                    backgroundColor: this.graphBGColorChange(),
                    callbacks: {
                        label: function(t, d) {
                            let label = d.labels[t.index];
                            let rawValue = d.datasets[0].data[t.index];
                            let value = Number(rawValue).toLocaleString("en-AU");
                            let total = d.datasets[0].data.reduce((sum, x) => sum + x);
                            let percentage = Number(rawValue / total * 100).toLocaleString("en-AU", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
                            return " " + label + ": " + value + " (" + percentage + "%)";
                        }
                    }
                },
                maintainAspectRatio: false
            }
        }
    },
    mounted() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.closedAppData = event.closedApplication.closedApplication

            let labels = this.closedAppData.map(closedReason => {
                return closedReason.reason
            })
            let datasets = this.closedAppData.map(closedReason => {
                return closedReason.count
            })

            this.datasets = {
                datasets: [
                    {
                        data: datasets,
                        backgroundColor: [
                            "#FF5722",
                            "#3F51B5",
                            "#009688",
                            "#2196F3",
                            "#673AB7",
                            "#FFC107",
                            "#4CAF50",
                            "#9E9E9E",
                            "#795548",
                            "#607D8B",
                            "#00BCD4",
                            "#E91E63"
                        ]
                    }
                ],
                labels: labels
            }

            this.graphColorChange()
            this.graphBGColorChange()
        })
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.closedAppData = event.closedApplication.closedApplication

            let labels = this.closedAppData.map(closedReason => {
                return closedReason.reason
            })
            let datasets = this.closedAppData.map(closedReason => {
                return closedReason.count
            })

            this.datasets = {
                datasets: [
                    {
                        data: datasets,
                        backgroundColor: [
                            "#FF5722",
                            "#3F51B5",
                            "#009688",
                            "#2196F3",
                            "#673AB7",
                            "#FFC107",
                            "#4CAF50",
                            "#9E9E9E",
                            "#795548",
                            "#607D8B",
                            "#00BCD4",
                            "#E91E63"
                        ]
                    }
                ],
                labels: labels
            }

            this.graphColorChange()
            this.graphBGColorChange()
        })
    },
    computed: {
    },
    destroyed() {
        Echo.leave(`dashboard.${this.tenantId}.${this.dashboard}`)
    },
    methods: {
        graphBGColorChange() {
            return this.appearance == "white" ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255,255,255, 0.9)'
        },
        graphColorChange() {
            return this.appearance == 'black' ? "#fff" : "#000"
        },
    }
}
</script>

<style scoped>
.move {
    cursor: move;
}
</style>
